"use client"

import { motion } from "framer-motion"

const TherapySection = () => {
  return (
    <section id="about" className="section-padding bg-[hsl(var(--background))]">
      <div className="max-w-6xl mx-auto">

        {/* Two-column: image left, copy right */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">

          {/* Left — image (sticky on lg+ so it pins to the top while copy scrolls) */}
          <motion.div
            initial={{ opacity: 0, x: -28 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:sticky lg:top-24"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3] bg-[hsl(var(--sage-light))]/40">
              <picture>
                <source type="image/webp" srcSet="/images/team-group-photo.webp" />
                <img
                  src="/images/team-group-photo.jpg"
                  alt="Battlefield Counseling therapy team"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                  width={1200}
                  height={900}
                />
              </picture>
            </div>
          </motion.div>

          {/* Right — copy */}
          <motion.div
            initial={{ opacity: 0, x: 28 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <p className="text-sm font-medium tracking-[0.18em] uppercase text-[hsl(var(--terracotta))] mb-3">
              Who We Are
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-5 leading-snug">
              We are your partners in overcoming life&apos;s toughest challenges.
            </h2>
            <div className="w-14 h-0.5 bg-[hsl(var(--sage))] mb-7" />

            <p className="text-base leading-relaxed text-muted-foreground mb-5">
              Does it feel like your past experiences are still controlling your present? Whether you are
              struggling with a recent life change, deep-seated trauma, or the feeling that your brain just
              works differently, you do not have to navigate these obstacles without a guide.
            </p>
            <p className="text-base leading-relaxed text-muted-foreground mb-8">
              At Battlefield Counseling in Greensboro, NC, we believe that healing is possible when you
              have the right tools and a team that truly understands the fight. Our therapists are licensed
              and trained in trauma-informed care, and most are certified in EMDR. We help people understand
              what they are experiencing, make sense of their story, and begin moving toward lasting healing
              with personalized support grounded in proven approaches.
            </p>

            <div className="flex justify-center text-center">
              <a
                href="/team"
                className="inline-flex items-center justify-center rounded-full bg-[hsl(var(--terracotta))] text-white px-9 py-3.5 text-base font-semibold hover:bg-[hsl(var(--terracotta))]/90 transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 text-center"
              >
                MEET OUR TEAM
              </a>
            </div>
          </motion.div>

        </div>

      </div>
    </section>
  )
}

export default TherapySection
